import {ChangeDetectionStrategy, Component, Input, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'ic-block',
  templateUrl: './block.component.html',
  styleUrls: ['./block.component.css'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BlockComponent {

  @Input() name: string = '';
  @Input() line: boolean = false;

  constructor() { }

}



// WEBPACK FOOTER //
// /app/src/app/layout/block/block.component.ts